import script from "./AiConfigurator.vue?vue&type=script&setup=true&lang=js"
export * from "./AiConfigurator.vue?vue&type=script&setup=true&lang=js"

import "./AiConfigurator.vue?vue&type=style&index=0&id=5bf664d7&scoped=true&lang=css"

import exportComponent from "/Users/marcin/Local Sites/dermaluce/app/public/wp-content/themes/dermaluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf664d7"]])

export default __exports__